import React from "react";
import { AccountSearchScreenContainer } from "../../../containers";

export const AccountSearchScreen = () => {
  return <AccountSearchScreenContainer />;
};
